
import { getBooleanDisplayValue } from '@ms/items-view/lib/private/components/fields/FieldHelper';
import { ComplianceFlags } from '../../dataSource/interfaces/CompliancePolicy';
import { ISPListRow } from '@ms/odsp-datasources/lib/dataSources/item/spListItemRetriever/interfaces/ISPGetItemResponse';

export function getComplianceRecordString(rowData: ISPListRow, isRecordVersionngFlightOn: boolean): string {
    return getBooleanDisplayValue(getComplianceRecordValue(rowData, isRecordVersionngFlightOn));
}

export function getComplianceRecordValue(rowData: ISPListRow, isRecordVersionngFlightOn: boolean): boolean {
    const complianceFlags: number = Number(rowData._ComplianceFlags || '0');

    /* tslint:disable:no-bitwise */
    if (isRecordVersionngFlightOn) {
        return ((complianceFlags & ComplianceFlags.TagPolicyRecord) === ComplianceFlags.TagPolicyRecord) ||
            getComplianceUnlockedRecordValue(rowData);
    } else {
        return (((complianceFlags & ComplianceFlags.TagPolicyRecord) === ComplianceFlags.TagPolicyRecord) &&
            ((complianceFlags & ComplianceFlags.TagPolicyHold) === ComplianceFlags.TagPolicyHold));
    }
    /* tslint:enable:no-bitwise */
}

export function getComplianceUnlockedRecordValue(rowData: ISPListRow): boolean {
    const complianceFlags: number = Number(rowData._ComplianceFlags || '0');
    /* tslint:disable:no-bitwise */
    return (complianceFlags & ComplianceFlags.TagPolicyRecordUnlocked) === ComplianceFlags.TagPolicyRecordUnlocked;
    /* tslint:enable:no-bitwise */
}

export function getComplianceRecordIconValue(rowData: ISPListRow, isRecordVersionngFlightOn: boolean): boolean {
    const complianceFlags: number = Number(rowData._ComplianceFlags || '0');

    /* tslint:disable:no-bitwise */
    if (isRecordVersionngFlightOn) {
        return (complianceFlags & ComplianceFlags.TagPolicyRecord) === ComplianceFlags.TagPolicyRecord;
    } else {
        return (((complianceFlags & ComplianceFlags.TagPolicyRecord) === ComplianceFlags.TagPolicyRecord) &&
            ((complianceFlags & ComplianceFlags.TagPolicyHold) === ComplianceFlags.TagPolicyHold));
    }
    /* tslint:enable:no-bitwise */
}
